module.exports = __webpack_public_path__ + "static/img/pinJie4.573160a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinJie4.png
// module id = DizG
// module chunks = 2